<template>
    <div>
      <trademark-bulletin-check-form :getTrademarkBulletinCheckList="getTrademarkBulletinCheckList" ref="trademarkBulletinCheckFormModal"></trademark-bulletin-check-form>
      <trademark-form ref="trademarkFormModal"></trademark-form>
      <p-d-f-viewer ref="bulletinInfoModal"></p-d-f-viewer>
         <b-row>
       <b-col class="col-12">
        <div class="d-flex justify-content-end align-items-end">
           <b-form-group>
             <label for="trademark-bulletin-employee-input">{{ $t('trademarkBulletinCheck.employee') }} </label>
                <b-form-select v-model="trademarkBulletinEmployeeSelect" @change="getTrademarkBulletinCheckList()" size="sm" value-field="id" text-field="name" :options="trademarkBulletinEmployeeOption"/>
           </b-form-group>
          <b-form-group>
            <div class="d-flex align-items-center">
              <vue-excel-xlsx :data="rows" :columns="columns" :file-name="'Stock'" :file-type="'xlsx'"
                :sheet-name="'sheetname'" class="excel-css" :excelAuthorizationConfirm="excelAuthorizationConfirm"
                :excelTrueOrFalse="excelTrueOrFalse">
                {{ $t('excel.excel') }}
              </vue-excel-xlsx>
            </div>
           </b-form-group>
        </div>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table
        id="trademarkBulletinCheckTable"
        ref="trademarkBulletinCheckTable" 
        :columns="columns"
        :rows="rows"
        styleClass="vgt-table condensed tableSize"
        :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" 
        :search-options="{
          enabled: true,
          externalQuery: searchTerm }"
        :pagination-options="{
          enabled: true,
          perPage:pageLength
        }"
      >
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.label === 'record_no'" class="text-nowrap">
            {{ $t('trademarkBulletinCheck.record_no') }}
          </span>
            <span v-else-if="props.column.label === 'application_no'" class="text-nowrap">
            {{ $t('trademarkBulletinCheck.application_no') }}
            </span>
            <span v-else-if="props.column.label === 'application_date'" class="text-nowrap">
            {{ $t('trademarkBulletinCheck.application_date') }}
            </span>
            <span v-else-if="props.column.label === 'stock_agent'">
              {{ $t('trademarkBulletinCheck.stock_agent') }}
            </span>
            <span v-else-if="props.column.label === 'employee'">
              {{ $t('trademarkBulletinCheck.employee') }}
            </span>
             <span v-else-if="props.column.label === 'bulletin_date'">
              {{ $t('trademarkBulletinCheck.bulletinDate') }}
            </span>
            <span v-else-if="props.column.label === 'process'" class="text-nowrap">
            {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Client Accounting Information Name -->
            <span v-if="props.column.field === 'applicationNo'" class="text-nowrap">
              <span>{{ props.row.applicationNo }}</span>
            </span>
            <!-- Column: Process -->
            <span v-else-if="props.column.field === 'process'">
              <span>
                <b-button v-b-tooltip.html :title="$t('others.compare')" v-b-modal.modal-top variant="info"
                  class="btn-icon mb-1 ml-1" size="sm" @click="getShowInfo(props.row.trademarkId)">
    
                  <feather-icon icon="EyeIcon" />
                </b-button>
              </span>
            </span>
          </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
                  </span>
                  <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                  <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
              </div>
              <div>
                  <b-pagination size="sm" :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                          <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                          <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                  </b-pagination>
              </div>
          </div>
      </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        pageLength: 10,
        dir: false,
        excelTrueOrFalse: null,
        columns: [
          {
            label: this.$t('trademarkBulletinCheck.record_no'),
            field: `recordNo`,
          },
          {
            label: this.$t('trademarkBulletinCheck.name'),
            field: `name`,
          },
          {
            label: this.$t('trademarkBulletinCheck.application_no'),
            field: `applicationNo`,
          },
          {
            label: this.$t('trademarkBulletinCheck.application_date'),
            field: `applicationDate`,
            formatFn: this.$formatFn,
          },
          {
            label: this.$t('trademarkBulletinCheck.stock_agent'),
            field: 'agent',
          },
          {
            label: this.$t('trademarkBulletinCheck.employee'),
            field: 'employee.name'
          },
          {
            label: this.$t('trademarkBulletinCheck.bulletin_date'),
            field: 'bulletinDate',
            formatFn: this.$formatFn
          },
          {
            label: 'process',
            field: 'process',
            width: '8em'
          },
        ],
        rows: [],
        searchTerm: '',
        trademarkBulletinEmployeeOption: [],
        trademarkBulletinEmployeeSelect :0,

      }
    },
    mounted() {
      this.getTrademarkBulletinCheckList()
    },
    methods: {
      async getInfo(trademarkId) {
        this.$refs.trademarkFormModal.showInfo(trademarkId)
      },
      async getShowInfo(trademarkId){
        this.$refs.trademarkBulletinCheckFormModal.showInfo(trademarkId)
      },
      async openBulletin(bulletinNo, bulletinPage, bulletinType){
        var bulletinString = bulletinNo
        this.$refs.bulletinInfoModal.showInfo(bulletinString, bulletinPage, bulletinType)
      },
      getTrademarkBulletinCheckList() {
        this.rows = []
        const data = { bulletinNo: this.bulletinNo,employeeId: this.trademarkBulletinEmployeeSelect}
        const controller = { name: 'Bulletin', actionName: 'GetTrademarkBulletinList'}
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          if (response.data.resultStatus == true) {
               this.trademarkBulletinEmployeeOption = response.data.employees
               this.trademarkBulletinEmployeeOption.splice(0, 0, this.$nullSelected())
               response.data.trademarkBulletinList.forEach(element => {
                this.rows.push(element)
              })
          } else {
              this.$WarningAlert(response.data.resultMessage)
          }
        })
      },
      addOrUpdate(id) {
        const data = {id: id}
        const controller = { name: 'Trademark', actionName: 'ConfirmTrademark' }
        const payload = { data: data, controller: controller }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                  if(response.data.resultStatus == true){
                    this.getTrademarkBulletinCheckList()
                    this.$SaveAlert()
                  } else {
                    this.$WarningAlert(response.data.resultMessage)
                  }
              })
      },
      excelAuthorizationConfirm() {
          const controller = { name: 'Trademark' }
          const payload = { controller: controller }
          this.$store.dispatch('moduleAuth/canExport', payload).then((response) => {
            if (response.data.resultStatus == true) {
              this.excelTrueOrFalse = 1
            }
            else {
              this.excelTrueOrFalse = 2
              this.$WarningAlert(response.data.resultMessage)
            }
          }
          )
      }
    },
  }
  </script>
<style>
   .tableSize {
    font-size: 13px!important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
  